module.exports = __webpack_public_path__ + "static/media/vip_content.883e33dc.png";